export interface MediaWsHandlers {
  onFrame: (data: ArrayBuffer) => void;
  onClose: (code: number, reason: string) => void;
  onError: (err: Event) => void;
}

export interface MediaWs {
  close: () => void;
}

export function openMediaWs(url: string, handlers: MediaWsHandlers, signal?: AbortSignal): Promise<MediaWs> {
  return new Promise((resolve, reject) => {
    if (signal?.aborted) {
      reject(new Error('aborted'));
      return;
    }
    const tokenPrefix = url.match(/token=([^&]+)/)?.[1]?.slice(0, 8) ?? 'unknown';
    // eslint-disable-next-line no-console
    console.info(`[media-ws] connecting mediaTokenPrefix=${tokenPrefix}`);
    const ws = new WebSocket(url);
    ws.binaryType = 'arraybuffer';
    let opened = false;
    const onAbort = () => { try { ws.close(1000, 'aborted'); } catch { /* ignore */ } };
    signal?.addEventListener('abort', onAbort, { once: true });

    ws.addEventListener('open', () => {
      opened = true;
      // eslint-disable-next-line no-console
      console.info(`[media-ws] open mediaTokenPrefix=${tokenPrefix}`);
      resolve({
        close: () => { try { ws.close(1000, 'client_disconnect'); } catch { /* ignore */ } },
      });
    });

    ws.addEventListener('message', (e) => {
      if (e.data instanceof ArrayBuffer) handlers.onFrame(e.data);
    });

    ws.addEventListener('close', (e) => {
      // eslint-disable-next-line no-console
      console.info(`[media-ws] close mediaTokenPrefix=${tokenPrefix} code=${e.code} reason=${e.reason}`);
      signal?.removeEventListener('abort', onAbort);
      handlers.onClose(e.code, e.reason);
      if (!opened) reject(new Error(`closed_before_open:${e.code}`));
    });

    ws.addEventListener('error', (e) => {
      handlers.onError(e);
      if (!opened) reject(new Error('media_ws_error'));
    });
  });
}

export function buildMediaUrl(baseUrl: string, mediaToken: string): string {
  const wsBase = baseUrl.replace(/^http/, 'ws');
  const params = new URLSearchParams({ token: mediaToken, role: 'client' });
  return `${wsBase}/ws/media?${params.toString()}`;
}
